import styled from 'styled-components';
import { rem } from '@/styles/theme';
import { Hr } from '@/components/atoms';

export const Wrapper = styled.div`
  display: flex;
  gap: ${rem(14)};
  cursor: pointer;
  padding: ${rem(10)} ${rem(18)};
  ${({ theme }) => theme.media.fold`
    padding: ${rem(8)} ${rem(20)};
  `}
`;

export const RightArea = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-bottom: ${rem(16)};
  border-bottom: ${({ theme }) => `1px solid ${theme.color['gray-200']}`};
`;

export const SubTitleArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(2)};
  margin: ${rem(8)} 0;
  ${({ theme }) => theme.media.fold`
    margin: ${rem(6)} 0;
  `}
`;
